import type PlannedBreakForm from 'modules/shift_management/lib/forms/PlannedBreakForm'
import ShiftConfigForm from 'modules/shift_management/lib/forms/ShiftConfigForm'
import type ShiftConfiguration from 'modules/shift_management/store/api/models/ShiftConfiguration'
import {
  DAY_TYPE,
  DEFAULT_REST_DAYS,
} from 'modules/shift_management/store/api/models/ShiftConfiguration'

export interface ShiftConfigWithBreaksForm {
  shiftConfig: ShiftConfigForm
  breaks: PlannedBreakForm[]
}

export const initialBlankForm = (day: number, canUseRestDays: boolean, editing: boolean) => {
  const defaultRestDays = canUseRestDays && !editing && DEFAULT_REST_DAYS.includes(day)
  const defaultEmptyCell = editing ? DAY_TYPE.emptyCell : DAY_TYPE.shift
  const dayType = defaultRestDays ? DAY_TYPE.restDay : defaultEmptyCell
  const shiftConfig = new ShiftConfigForm({
    weekday: day,
    day_type: dayType,
  })

  return {
    shiftConfig,
    breaks: [],
  }
}

export const blankShiftForm = (day: number) => {
  const shiftConfig = new ShiftConfigForm({
    weekday: day,
    day_type: DAY_TYPE.shift,
  })
  return { shiftConfig, breaks: [] }
}

export const shiftFormWithBreaks = (
  day: number,
  shift: ShiftConfiguration,
  breaks: PlannedBreakForm[]
) => {
  const shiftConfig = new ShiftConfigForm({
    id: shift.get('id'),
    weekday: day,
    start_at: shift.get('start_at'),
    end_at: shift.get('end_at'),
    day_type: shift.get('day_type'),
  })

  return {
    shiftConfig,
    breaks,
  }
}

export const copyShiftForm = (day: number, form: ShiftConfigWithBreaksForm) => {
  const shiftConfig = new ShiftConfigForm({
    weekday: day,
    start_at: form.shiftConfig.get('start_at').value,
    end_at: form.shiftConfig.get('end_at').value,
    day_type: form.shiftConfig.get('day_type').value,
  })

  const copiedBreaks = form.breaks.map((b) => b.clone())

  return { shiftConfig, breaks: copiedBreaks }
}
